export const productStatus = {
  Unavailable: "Non disponible",
  Rented: "Déjà loué",
  Available: "Disponible",
};
